import { useCallback, useContext, useEffect, useSyncExternalStore } from 'react';
import { ReactReduxContext } from 'react-redux';
// import { useDispatch } from 'react-redux';
// import { setToken as setReduxToken, clearToken as clearReduxToken } from '../../features/auth/authSlice';
import { useAuth } from './useAuth';

const useOptionalReduxSelector = (selector) => {
  const context = useContext(ReactReduxContext);
  const store = context?.store;
  const subscription = context?.subscription;

  const subscribe = useCallback(
    (listener) => {
      if (!subscription) {
        return () => {};
      }
      return subscription.addNestedSub(listener);
    },
    [subscription]
  );

  const getSnapshot = useCallback(() => {
    if (!store) return undefined;
    return selector(store.getState());
  }, [store, selector]);

  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
};

/**
 * Hook que sincroniza el estado de autenticación entre Redux y Zustand
 * Evita problemas de desincronización durante el proceso de refactorización
 */
export const useAuthSync = () => {
  const reduxToken = useOptionalReduxSelector((state) => state?.auth?.token);
  const reduxExpirationTime = useOptionalReduxSelector((state) => state?.auth?.expirationTime);
  
  const {
    token: zustandToken,
    expirationTime: zustandExpirationTime,
    setAuth,
    clearAuth,
    user,
  } = useAuth();

  useEffect(() => {
    const isTokenValid = (token, expirationTime) => {
      return token && expirationTime && new Date() < new Date(expirationTime);
    };

    const reduxIsValid = isTokenValid(reduxToken, reduxExpirationTime);
    const zustandIsValid = isTokenValid(zustandToken, zustandExpirationTime);

    if (reduxIsValid && !zustandIsValid) {
      setAuth(reduxToken, reduxExpirationTime, user, null);
    } else if (!reduxIsValid && !zustandIsValid && (reduxToken || zustandToken)) {
      if (zustandToken) {
        clearAuth();
      }
      // if (reduxToken) {
      //   dispatch(clearReduxToken());
      // }
    }

    // else if (zustandIsValid && !reduxIsValid) {
    //   dispatch(setReduxToken({ token: zustandToken, expirationTime: zustandExpirationTime }));
    // }

    // else if (reduxIsValid && zustandIsValid && reduxToken !== zustandToken) {
    //   const reduxExp = new Date(reduxExpirationTime);
    //   const zustandExp = new Date(zustandExpirationTime);
    //   if (reduxExp > zustandExp) {
    //     setAuth(reduxToken, reduxExpirationTime, user, null);
    //   } else {
    //     dispatch(setReduxToken({ token: zustandToken, expirationTime: zustandExpirationTime }));
    //   }
    // }

  }, [reduxToken, reduxExpirationTime, zustandToken, zustandExpirationTime, setAuth, clearAuth, user]);

  const finalToken = reduxToken || zustandToken;
  const finalExpirationTime = reduxExpirationTime || zustandExpirationTime;
  const isValidToken = finalToken && finalExpirationTime && new Date() < new Date(finalExpirationTime);

  return {
    isAuthenticated: isValidToken,
    token: finalToken,
    expirationTime: finalExpirationTime
  };
};
